import { render, staticRenderFns } from "./wood-info.vue?vue&type=template&id=2751c909&scoped=true&"
import script from "./wood-info.vue?vue&type=script&lang=ts&"
export * from "./wood-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2751c909",
  null
  
)

export default component.exports